import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

export const selectLoanProgramOptionsDetails = createSelector(
  selectLoanApplication,
  ({ loanProgramOptionsDetails }) => loanProgramOptionsDetails,
);

// Only the Lender engines quote off an uploaded rate sheet; Optimal Blue / LoanSifter details carry no such date.
export const selectRateSheetModificationDate = createSelector(
  selectLoanProgramOptionsDetails,
  details => details?.rateSheetModificationDate ?? null,
);
